import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSession } from '../Cart-Context/session';
import { fetchCartProducts } from '../Cart-Context/context';
import { trackEvent } from '../utils/trackEvents'; 
import '../App.css';

const OrderComplete = () => {
    const { sessionId, experimentId } = useSession(); 
    const navigate = useNavigate();
    const userRole = localStorage.getItem("userRole");

    useEffect(() => {
        window.dispatchEvent(new Event("cartUpdated"));

        // Cleanup function: This runs when the user leaves this page
        return () => {
            if (userRole !== 'researcher') {
                localStorage.removeItem("sessionId");
                localStorage.removeItem("cartId");
                localStorage.removeItem("experimentId");
                
                // Clear any cached products or incidental session data
                sessionStorage.clear(); 
                
                window.dispatchEvent(new Event("cartUpdated"));
            }
        };
    }, [userRole]);
    
    const handleSurveyClick = () => {
        // Track that they finished and are moving to the questionnaire
        trackEvent(sessionId, 'CLICK', 'Proceed to Qualtrics', {}, experimentId);

        setTimeout(() => {
            if (userRole !== 'researcher') {
                localStorage.removeItem("sessionId");
                localStorage.removeItem("cartId");
                localStorage.removeItem("experimentId");
                
                // Forces a hard reset to guest mode
                window.location.href = '/'; 
            }
        }, 10000); 
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(sessionId);
        alert("Session ID copied to clipboard!");
    };

    return (
        <main className="page-container">
            <div className="checkout-container success-page">
                <h1 className="welcome-title">Thanks for your order!</h1>
                
                {userRole === 'researcher' ? (
                    <div className="researcher-success-view">
                        <p>This test order has been completed. Researchers do not have their sessions reset automatically.</p>
                        <button className="shop-now-btn" onClick={() => navigate('/')}>
                            Return to Home
                        </button>
                    </div>
                ) : (
                    <>
                        <p>Thank you for participating in our research study.</p>
                        
                        <div className="session-id-box">
                            <p><strong>Step 1:</strong> Copy your unique Session ID</p>
                            <code className="session-code">{sessionId}</code>
                            <button className="copy-btn" onClick={copyToClipboard}>
                                Copy Session ID
                            </button>
                        </div>

                        <div className="survey-link-section">
                            <p><strong>Step 2:</strong> Click the link below to finish the survey.</p>
                            <p><i>You will need to paste your Session ID into the Qualtrics form.</i></p>
                            <a 
                                href="https://qualtricsxm5nprhp4tk.qualtrics.com/jfe/form/SV_0UFA2TE8trrVxKC" 
                                className="shop-now-btn" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                onClick={handleSurveyClick}
                            >
                                Proceed to Qualtrics Survey
                            </a>
                        </div>
                    </>
                )}
            </div>
        </main>
    );
};

export default OrderComplete;